import { dismissToast, useUi } from '@/store/ui'
import './Toast.css'

/** The one toast: a line of text and, usually, a button: Undo, or Show for a task added out of view. */
export function Toast() {
  const toast = useUi((s) => s.toast)
  const quickAddOpen = useUi((s) => s.quickAddOpen)
  if (!toast) return null
  const onAction = async () => {
    const run = toast.action?.run
    dismissToast()
    if (run) await run()
  }
  return (
    <div className={`toast ${quickAddOpen ? 'toast--raised' : ''}`} role="status">
      <span className="toast__text">{toast.text}</span>
      {toast.action && (
        <button type="button" className="toast__action" onClick={() => void onAction()}>
          {toast.action.label}
        </button>
      )}
    </div>
  )
}
